// Angular Core
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-error-badge',
    templateUrl: './error-badge.component.html',
    styleUrls: ['./error-badge.component.scss'],
    standalone: false
})
export class ErrorBadgeComponent {
  // Public variables
  public displayErrorMessage = false;
  // Event emitters
  @Output() onReprocess = new EventEmitter<any>();
  //Inputs
  @Input() errorHeader = '';
  @Input() errorBody = '';
  @Input() allowReprocessing = false;

  constructor() {}

  public onClickReprocess() {
    this.onReprocess.emit();
  }
}
